import { useTranslation, VOICE_ACTIONS } from "@next-platform/client-common-core";
import { useCallback, useState } from "react";

import { RateSpeechActions, RateSpeechModal } from "../RateSpeechModal";
import { ERROR_MESSAGES, IVoiceRatingModalProps, LABEL, SUCCESS_MESSAGES } from "./types";
import getDislikeFeedbackOptions from "./utils";

const VoiceRatingModal = ({
  messageId,
  voiceId,
  showRateVoiceModal,
  onCloseRateModal,
  rateVoiceQuality,
  setInfoMessageForRatingVoice,
  loadingFromPreferredVoice,
}: IVoiceRatingModalProps) => {
  const { t } = useTranslation();
  const [stateSelectionAction, setStateSelectionAction] = useState<RateSpeechActions | null>(null);
  const feedBackOptions = stateSelectionAction === RateSpeechActions.DISLIKE ? getDislikeFeedbackOptions(t) : [];
  const isRatingApiInProgress = loadingFromPreferredVoice?.isLoading && loadingFromPreferredVoice?.loadingType === VOICE_ACTIONS.RATE_VOICE_QUALITY;

  const saveFeedback = useCallback(
    async (feedBack: LABEL) => {
      if (!feedBack) {
        return;
      }
      try {
        await rateVoiceQuality({ message_id: messageId, voice_id: voiceId, label: feedBack });
        setInfoMessageForRatingVoice(messageId, SUCCESS_MESSAGES.RATE_VOICE_QUALITY);
      } catch {
        setInfoMessageForRatingVoice(messageId, ERROR_MESSAGES.RATE_VOICE_QUALITY);
      } finally {
        onCloseRateModal();
        setStateSelectionAction(null);
      }
    },
    [messageId, onCloseRateModal, rateVoiceQuality, setInfoMessageForRatingVoice, voiceId],
  );

  const voiceRateActionHandler = useCallback(
    (action: RateSpeechActions, feedback?: LABEL) => {
      if (action === RateSpeechActions.CONFIRM) {
        switch (stateSelectionAction) {
          case RateSpeechActions.LIKE:
            return saveFeedback(LABEL.LIKE);
          case RateSpeechActions.DISLIKE:
            return feedback && saveFeedback(feedback);
          case RateSpeechActions.FAVORITE:
            return saveFeedback(LABEL.LOVE);
        }
      } else {
        setStateSelectionAction(action);
      }
    },
    [saveFeedback, stateSelectionAction],
  );
  return (
    <RateSpeechModal
      listItems={feedBackOptions}
      open={showRateVoiceModal}
      onOpenChange={onCloseRateModal}
      actionHandler={voiceRateActionHandler}
      voiceRateLoading={isRatingApiInProgress}
    />
  );
};

export default VoiceRatingModal;
